<app-mrp-scrolltop></app-mrp-scrolltop>

<!-- Main -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">
        <div class="col-12-large">

          <div>
            <img src="assets/images/history/robertsrules.png" alt="Robert's Rules of Order" class="hero-header-img">
          </div>

          <div class="right-menu">
            <mat-form-field appearance="fill">
              <mat-label>Tools...</mat-label>
              <mat-select (selectionChange)="onRouteSelect($event.value)">
                @for (routeOption of delegateroutes; track routeOption) {
                <mat-option [value]="routeOption.path">
                  {{ routeOption.label }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <h4><b>Robert's Rules of Order</b></h4>

          <p>Robert's Rules of Order are the official parliamentary rules of the party.
          </p>
          <h5><b>The book:</b></h5>
          <p><a href="https://www.amazon.com/Roberts-Rules-Order-Newly-Revised/dp/1541736699">Robert's Rules of Order,
              12th Ed</a> can be purchased here.
          </p>
        </div>

      </div>
    </div>
  </div>
</section>

<!-- section 1 -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">
        <div class="col-12-large">

          <h5><b>Why Have Rules?</b></h5>

          <p>
            In order for everyone to participate, in order for everyone to be heard, and in order for the group to make
            decisions fairly, we need rules.
          </p>
          <p>
            It's difficult to hold a fair meeting with a group of people. As the group gets larger, this becomes more
            and more difficult.
          </p>

          <p><a routerLink="/questions">Common Meeting Questions</a></p>
          <p><a routerLink="/bootcamp">Training</a></p>
          <p><a routerLink="/zoom">Zoom Training</a></p>



          <blockquote class="doc-quotes">
            <p>"I know no safe depository of the ultimate powers of society but the people themselves; and if we think
              them not enlightened enough to exercise their control with a wholesome discretion, the remedy is not to
              take it from them, but to inform their discretion by education."
              -Thomas Jefferson, Letter to W. C. Jarvis, September 28, 1820</p>
          </blockquote>


        </div>

        <div class="col-12-large ">


        </div>

      </div>
    </div>
  </div>
</section>


<!-- section 3 -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">
        <div class="col-12-large">
          <h5><b>Tools For Better Meetings</b></h5>

          <p>PDF files for download...</p>

          <ol>
            <li><a href="/assets/pdf/RONRMotionPrecedence.pdf">Motion Precedence Chart</a></li>
            <li><a href="/assets/pdf/RONRMeetingCheatsheet.pdf">Meeting Cheat Sheet</a></li>
            <li><a href="/assets/pdf/CommitmentOfChair.pdf">Chair Commitment</a></li>
            <li><a href="/assets/pdf/RONRMemberResponsibilities.pdf">Member Responsibilities</a></li>
            <li><a href="/assets/pdf/RONRProhibitedActions.pdf">Prohibited Actions</a></li>
          </ol>

          <blockquote class="doc-quotes">
            <p>"The republican is the only form of government which is not eternally at open or secret war with the
              rights of mankind."
              -Thomas Jefferson, Letter to William Hunter, 1790</p>
          </blockquote>

        </div>

        <div class="col-12-large ">



        </div>

      </div>
    </div>
  </div>
</section>


<!---------------------END OF PAGE ---------------------------------------------------------------->